import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { supportApi as r } from "@maat/api-main";
//#region src/support/useCreateCallbackMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createCallback(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.myCallbacks() });
		}
	});
};
//#endregion
export { i as useCreateCallbackMutation };
